var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stats-chart-analysis',{attrs:{"subtitle":_vm.subtitle,"title":_vm.title,"action":_vm.action,"stats":_vm.stats}},[_c('horizontal-bar-chart',{attrs:{"data":_vm.data,"options":_vm.option}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }